import { ChatListResponseType, ChatStateType, PayloadType } from "@/common/types";
import Types from "../types";

const chatInitialState: ChatStateType = {
  chats: null,
  chatList: [],
  chatHistory: [],
  unreadCount: 0,
};

export const chatReducer = (
  state = chatInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_CHAT_LIST:
      return {
        ...state,
        chats: action.payload,
        chatList: (action.payload as ChatListResponseType)?.results || [],
      };
    case Types.SET_MORE_CHAT_LIST:
      return {
        ...state,
        chatList: [...state.chatList].concat((action.payload as ChatListResponseType)?.results || []),
      };
    case Types.SET_CHAT_HISTORY:
      return {
        ...state,
        chatHistory: action.payload,
      };
    case Types.CLEAR_CHAT_LIST:
      return {
        ...state,
        chatList: [],
      };
    case Types.CLEAR_CHAT_HISTORY:
      return {
        ...state,
        chatHistory: null,
      };
    case Types.SET_CHAT_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload,
      };
    default:
      return state;
  }
};